import { render, staticRenderFns } from "./SlidingPanel.vue?vue&type=template&id=5f51d959&scoped=true&"
import script from "./SlidingPanel.vue?vue&type=script&lang=ts&"
export * from "./SlidingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SlidingPanel.vue?vue&type=style&index=0&id=5f51d959&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51d959",
  null
  
)

export default component.exports